import { useMemo, useState } from 'react'

import { useOutsideClick } from 'app/common/presentation'

import { CodeTag, Menu } from 'components'

import styles from './EventInput.module.scss'

interface EventInputProps {
  addLabel: string
  eventNames: string[]
  onChange: (events: string[]) => void
  removeLabel: string
  value: string[]
}

const EventInput = ({ addLabel, eventNames, onChange, removeLabel, value }: EventInputProps) => {
  const [open, setOpen] = useState(false)
  const ref = useOutsideClick<HTMLDivElement>(() => setOpen(false))

  const options = useMemo(
    () => eventNames.filter((eventName) => !value.includes(eventName)),
    [eventNames, value],
  )

  const selectEvent = (eventName: string) => {
    onChange([...value, eventName])
    setOpen(false)
  }

  const removeEvent = (eventName: string) =>
    onChange(value.filter((selectedEventName) => selectedEventName !== eventName))

  return (
    <div className={styles.eventInput} ref={ref}>
      <div className={styles.control}>
        {value.map((eventName) => (
          <CodeTag
            color="grey"
            key={eventName}
            onRemove={() => removeEvent(eventName)}
            removeLabel={`${removeLabel}: ${eventName}`}
          >
            {eventName}
          </CodeTag>
        ))}
        {options.length > 0 && (
          <div className={styles.addEvent}>
            <button
              aria-expanded={open}
              className={styles.addButton}
              onClick={() => setOpen((isOpen) => !isOpen)}
              type="button"
            >
              {addLabel} +
            </button>

            {open && (
              <Menu.Menu className={styles.menu}>
                {options.map((eventName) => (
                  <Menu.MenuItem
                    className={styles.menuItem}
                    key={eventName}
                    label={eventName}
                    onClick={() => selectEvent(eventName)}
                    role="menuitem"
                  />
                ))}
              </Menu.Menu>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default EventInput
